import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initCollectionSearchFilters from '../sections/collection/initCollectionSearchFilters';
import initLoadMore from '../components/load-more';

ready(() => {
  initCollectionSearchFilters();
  initLoadMore();
});

onShopifySectionLoad(() => {
  initCollectionSearchFilters();
  initLoadMore();
});
